module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jWfor"))).then(() => parcelRequire('hEqeo'));